export const SECTION_TEMPLATE_ID = 'src/components/SectionTemplate/Search/Section_Template_Id'
export const setSectionTemplateSearchId = (data) => {
    return {
        type: SECTION_TEMPLATE_ID,
        data
    }
}